/**
 * Created by frank.law on 11/13/17.
 */
import { combineReducers } from 'redux';
//import { combineForms } from 'react-redux-form';
import login from './login';
import forms from './forms';

export default combineReducers({
    login,
    forms
});
